export default "__VITE_ASSET__B7LWikF0__"